/*function to format date from Database/API */

const getOrdinalSuffix = (day) => {
  const suffixes = {
    1: 'st',
    2: 'nd',
    3: 'rd',
    21: 'st',
    22: 'nd',
    23: 'rd',
    31: 'st',
  };

  const suffix = suffixes[day] || 'th';
  return `${day}${suffix}`;
};

export const getTimeFormatted = (dateString) => {
  const date = new Date(dateString);
  const dayOfWeek = date.toLocaleString('en-US', { weekday: 'short' });
  const month = date.toLocaleString('en-US', { month: 'short' });
  const day = date.getDate();
  const hour = date.getHours();
  const minute = date.getMinutes();
  const meridiem = hour >= 12 ? 'PM' : 'AM';
  const formattedHour = hour % 12 || 12;
  const formattedMinute = minute.toString().padStart(2, '0');
  const ordinalSuffix = getOrdinalSuffix(day);

  return `${dayOfWeek}, ${month} ${ordinalSuffix}, ${formattedHour}${meridiem}`;
};
